<mat-card id="email-verification-card">
  <mat-card-content class="card-content">
    <!-- Logo Section -->
    <div class="logo-container" class="bftllogo">
      <img src="../../assets/i-logo.png" width="86px" color="black" alt="Logo" class="logo"/>
    </div>

    <!-- Welcome Section -->
    <div class="welcome-section">
      <h2>{{ translations.emailVerification }}</h2>
      <p class="subtitle"> {{ translations.subtitle }} </p>
    </div>

    <!-- Email Form -->
    <form [formGroup]="emailForm" (ngSubmit)="sendOtp()">
      <div class="form-field">
        <input
          type="email"
          formControlName="email"
          [placeholder]="translations.emailPlaceholder"
          (keydown.space)="preventSpace($event)"
          [class.error]="emailForm.get('email')?.touched && emailForm.get('email')?.invalid"
          (keyup)="validateEmail()" />
          <mat-icon class="icon1">email</mat-icon>
      </div>

      <app-turnstile
        [siteKey]="siteKey"
        (token)="onTokenReceived($event)">
      </app-turnstile>


      @if (generatedOtp) {
        <div class="form-field">
          <mat-icon class="form-icon">lock</mat-icon>
          <input
            type="text"
            formControlName="otp"
            [placeholder]="translations.otpPlaceholder"
            (keydown.space)="preventSpace($event)"
            [class.error]="emailForm.get('otp')?.touched && emailForm.get('otp')?.invalid" />
        </div>
      }

      @if (!generatedOtp) {
        <button type="submit" class="submit-btn"
          [disabled]="!emailForm.get('email')?.valid || !turnstileToken">
          <span> {{ translations.sendOtpButton }} </span>
        </button>
      }

      <!-- OTP Verification and Resend Buttons -->
      @if (generatedOtp) {
        <div class="button-group">
          <button type="button" class="submit-btn verify-btn" (click)="verifyOtp()">
            <span> {{ translations.verifyButton }} </span>
          </button>
          @if (otpError || isOTPGenerated) {
            <span class="resend">{{ translations.otpnotreceived }}
              <button type="button" class="resend-button" (click)="resendOtp()">
                <span> {{ translations.resendButton }} </span>
              </button>
            </span>
          }
        </div>
      }
    </form>
  </mat-card-content>
</mat-card>

    <!-- Language Switcher -->
    <div class="custom-language">
      <a (click)="switchLanguage('en')">English</a>
      <a (click)="switchLanguage('zh')">中文</a>
    </div>

    <!-- Footer -->
    <div class="copyrightext">
      {{ translations.footer }}
    </div>
